/**
 * Helper functions validation.js
 *
 * @namespace validation
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/helper/validation.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

/**
 * @function validation.isNumeric
 */
export const isNumeric = (input) => {
    if (typeof input === 'string') {
        return !isNaN(input) && !isNaN(parseFloat(input));
    }else{
        return typeof input === 'number';
    }
}